// extracted by mini-css-extract-plugin
export default {"table":"table--ffIxK","largerFirstColumn":"largerFirstColumn--ffIxK","firstColumnOverride":"firstColumnOverride--ffIxK"};